import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

interface UseNavigationBlockerReturn {
  isBlocked: boolean;
  proceed: () => void;
  reset: () => void;
}

/** Holds back in-app navigation and full page unloads while `shouldBlock` is true.
 *
 * Requires a data router (see `createBrowserRouter` in main.tsx). */
export function useNavigationBlocker(shouldBlock: boolean): UseNavigationBlockerReturn {
  const blocker = useBlocker(shouldBlock);

  useEffect(() => {
    if (!shouldBlock) return;

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [shouldBlock]);

  return {
    isBlocked: blocker.state === 'blocked',
    proceed: () => {
      if (blocker.state === 'blocked') {
        blocker.proceed();
      }
    },
    reset: () => {
      if (blocker.state === 'blocked') {
        blocker.reset();
      }
    },
  };
}
